import { render, staticRenderFns } from "./PhoneSlash.vue?vue&type=template&id=156d72c1&"
import script from "./PhoneSlash.vue?vue&type=script&lang=js&"
export * from "./PhoneSlash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports